export const SettingsTabs = ['devices', 'locations', 'partners'] as const;
export type SettingsTab = (typeof SettingsTabs)[number];
